import { useCurrentId } from 'features/messaging/hooks'
import { useGetProps } from 'features/messaging/hooks/useFilters'
import { memo, type MutableRefObject } from 'react'
import { useIntersectionObserver } from 'shared/hooks'

import { api } from '../../api'
import { Thumbnail, ThumbnailSkeleton } from '../Thumbnail'

function NextPack_({
	cursor,
	rootRef
}: {
	cursor: string
	rootRef: MutableRefObject<HTMLUListElement | null>
}) {
	const current = useCurrentId()

	const [ref, entry] = useIntersectionObserver({
		root: rootRef.current,
		// rootMargin: '200% 0% 0%',
		threshold: 1
	})

    const { filter, mailboxFilter, search } = useGetProps()

    const query = api.useConversationsQuery(
        { cursor, filter, mailboxFilter, search },
		{
			skip: !entry?.isIntersecting
		}
	)

	if (query.isError) {
		return null
	}

	if (!query.isSuccess) {
		return (
			<>
				<ThumbnailSkeleton innerRef={ref} key={'i'} />
				<ThumbnailSkeleton key={1} />
				<ThumbnailSkeleton key={2} />
			</>
		)
	}

	const hasNextCursor = Boolean(
		query.isSuccess && query.currentData?.nextCursor
	)

	return (
		<>
			{query.currentData?.items.map(conversation => (
				<Thumbnail
					id={conversation.entity_id}
					isSelected={conversation.entity_id === current}
					key={conversation.entity_id}
				/>
			))}

			{hasNextCursor && (
				<NextPack_ cursor={query.currentData!.nextCursor!} rootRef={rootRef} />
			)}
		</>
	)
}

export const NextPack = memo(NextPack_)
